import { Alert, AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, AlertIcon, Badge, Box, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Button, Card, CardBody, CardHeader, Container, Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerHeader, DrawerOverlay, Flex, FormControl, FormLabel, Grid, IconButton, Image, Input, InputGroup, InputLeftElement, Menu, MenuButton, MenuItem, MenuList, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Popover, PopoverArrow, PopoverBody, PopoverContent, PopoverTrigger, Select, Skeleton, Stack, Table, TableContainer, Tbody, Td, Text, Textarea, Th, Thead, Tr, useColorModeValue, useDisclosure, useToast, Link, HStack, Tooltip, Center, Icon, Portal, InputRightElement, CloseButton } from '@chakra-ui/react'
import React, { useCallback, useEffect, useState } from 'react'
import Resizer from "react-image-file-resizer";
import { useNavigate } from 'react-router-dom'
import { useStateContext } from '../../../context/ContextProvider';
import axiosClient from '../../../axios-client';
import { DeleteIcon, EditIcon, HamburgerIcon, SearchIcon, AttachmentIcon, CloseIcon } from '@chakra-ui/icons';
import { PiPlusBold } from 'react-icons/pi';
import { FaFilePdf, FaImage } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import MyPagination from '../../../components/MyPagination';
import { handlePriceChange, formatPriceForBackend } from '../../../utils/priceFormatter';
import { DateRange } from 'react-date-range';
import format from 'date-fns/format';
import fr from 'date-fns/locale/fr';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { GrPowerReset } from 'react-icons/gr';
import { RiFileExcel2Fill } from 'react-icons/ri';


function GestFinance() {
    const navigate = useNavigate()
    const { t } = useTranslation();
    const { user, setToken, setUser, currentBusiness } = useStateContext();
    const toast = useToast()
    const [id, setId] = useState(null);
    const cancelRef = React.useRef()
    const [date, setDate] = useState("")
    const [dateDebutValue, setDateDebutValue] = useState("");
    const [dateFinValue, setDateFinValue] = useState("");

    const [selectionRange, setSelectionRange] = useState({
        startDate: new Date(),
        endDate: new Date(),
        key: 'selection',
    });

    const handleSelectDateRange = (ranges) => {
        const { startDate, endDate } = ranges.selection;
        setSelectionRange(ranges.selection);
        setDateDebutValue(format(startDate, 'yyyy-MM-dd'));
        setDateFinValue(format(endDate, 'yyyy-MM-dd'));
    };

    const clearDateRange = () => {
        setDateDebutValue("");
        setDateFinValue("");
        setSelectionRange({
            startDate: new Date(),
            endDate: new Date(),
            key: 'selection',
        });
    };

    const resetFilters = () => {
        setSearchTerm("");
        clearDateRange();
        setCurrentPage(0);
    };

    const handleExportExcel = async () => {
        try {
            const response = await axiosClient.get(`/export-finances/${user?.id}/?search_term=${searchTerm}&dateDebut=${dateDebutValue}&dateFin=${dateFinValue}&business=${currentBusiness?.id}`, {
                responseType: 'blob',
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'finances.xlsx');
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);

            toast({
                description: t("Le fichier a été exporté avec succès."),
                variant: 'left-accent',
                status: 'success',
                duration: 3000,
                isClosable: true,
                position: 'bottom-right'
            });
        } catch (error) {
            toast({
                description: t("Une erreur s'est produite lors de l'exportation du fichier."),
                variant: 'left-accent',
                status: 'error',
                duration: 3000,
                isClosable: true,
                position: 'bottom-right'
            });
        }
    };
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [isExportAlertOpen, setIsExportAlertOpen] = useState(false);

    const onOpenAlert = () => {
        setIsAlertOpen(true);
    };
    const onCloseAlert = () => {
        setIsAlertOpen(false);
    };
    const onOpenExportAlert = () => {
        setIsExportAlertOpen(true);
    };
    const onCloseExportAlert = () => {
        setIsExportAlertOpen(false);
    };
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [isEdit, setIsEdit] = useState(false)
    const [message, setMessage] = useState('');
    const [searchTerm, setSearchTerm] = useState('');

    const [data, setData] = useState([]);
    const [paginationData, setPaginationData] = useState()
    const [loadingData, setLoadingData] = useState(true)

    // Form states
    const [factures, setFactures] = useState("");
    const [compteRecepteur, setCompteRecepteur] = useState("");
    const [source, setSource] = useState("");
    const [total, setTotal] = useState(0);
    const [receipts, setReceipts] = useState([]);
    const [existingReceipts, setExistingReceipts] = useState([]);
    const [isReceiptAlertOpen, setIsReceiptAlertOpen] = useState(false);
    const [receiptToDeleteId, setReceiptToDeleteId] = useState(null);
    const [financeId, setFinanceId] = useState(null);

    const PAGE_SIZE = 10;
    const [pageSize, setPageSize] = useState(PAGE_SIZE);
    const [currentPage, setCurrentPage] = useState(0);

    const handlePageSizeChange = (event) => {
        const newSize = parseInt(event.target.value, 10);
        setPageSize(newSize);
        setCurrentPage(0);
    };

    const resetForm = () => {
        setFactures("");
        setCompteRecepteur("");
        setSource("");
        setTotal(0);
        setReceipts([]);
        setExistingReceipts([]);
        setFinanceId(null);
        setMessage("");
    }

    const fetchData = useCallback(() => {
        if (user?.id) {
            setLoadingData(true);
            axiosClient.get(`/finances/getAllFinances/?page_size=${pageSize}&page=${currentPage + 1}&search_term=${searchTerm}&client=${user?.id}&dateDebut=${dateDebutValue}&dateFin=${dateFinValue}&business=${currentBusiness?.id}`)
                .then((response) => {
                    setData(response.data.results || []);
                    setPaginationData(response.data);
                    setLoadingData(false);
                })
                .catch((error) => {
                    // // console.error(error);
                    setLoadingData(false);
                });
        }
    }, [user?.id, pageSize, currentPage, searchTerm, dateDebutValue, dateFinValue, currentBusiness?.id]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const handleSave = () => {
        if (!factures) {
            setMessage(t("Veuillez remplir le champ factures"));
            return;
        }

        const formData = new FormData();
        formData.append("factures", factures);
        formData.append("compte_recepteur", compteRecepteur);
        formData.append("source", source);
        formData.append("total", formatPriceForBackend(total));
        
        receipts.forEach((file) => {
            formData.append("receipts", file);
        });

        formData.append("business", currentBusiness?.id);
        formData.append("added_by", user.id);

        const request = isEdit
            ? axiosClient.patch(`/finances/${financeId}/`, formData)
            : axiosClient.post('/finances/', formData);

        request.then(() => {
            fetchData();
            resetForm();
            onClose();
            toast({
                description: isEdit ? t("Facture modifiée avec succès") : t("Facture ajoutée avec succès"),
                status: 'success',
                duration: 2000,
                isClosable: true,
                variant: 'left-accent',
            });
        }).catch(err => {
            // // console.error(err);
            setMessage(t("Une erreur est survenue"));
        });
    }

    const handleDelete = (id) => {
        axiosClient.patch(`/finances/${id}/`, { is_deleted: true })
            .then(() => {
                fetchData();
                toast({
                    description: t("Facture supprimée avec succès"),
                    status: 'warning',
                    duration: 2000,
                    isClosable: true,
                    variant: 'left-accent',
                });
            })
            .catch(() => {});
        onCloseAlert();
    }

    const openEdit = (row) => {
        setIsEdit(true);
        setFinanceId(row.id);
        setFactures(row.factures);
        setSource(row.source);
        setCompteRecepteur(row.compte_recepteur || "");
        setTotal(row.total);
        setReceipts([]);
        
        const legacy = row.recu ? [{ id: 'legacy', file: row.recu, isLegacy: true }] : [];
        setExistingReceipts([...(row.receipts || []), ...legacy]);
        onOpen();
    }

    const handleDeleteReceipt = (receiptId) => {
        setReceiptToDeleteId(receiptId);
        setIsReceiptAlertOpen(true);
    }

    const confirmDeleteReceipt = () => {
        if (receiptToDeleteId === 'legacy') {
            axiosClient.patch(`/finances/${financeId}/`, { recu: null })
                .then(() => {
                    setExistingReceipts(existingReceipts.filter(r => r.id !== 'legacy'));
                    fetchData();
                    toast({ description: t("Ancien reçu supprimé"), status: 'success' });
                    setIsReceiptAlertOpen(false);
                })
                .catch(() => {});
        } else {
            axiosClient.delete(`/finances/deleteReceipt/?receiptId=${receiptToDeleteId}`)
                .then(() => {
                    setExistingReceipts(existingReceipts.filter(r => r.id !== receiptToDeleteId));
                    fetchData();
                    toast({ description: t("Reçu supprimé"), status: 'success' });
                    setIsReceiptAlertOpen(false);
                })
                .catch(() => {});
        }
    }

    const txtColor = useColorModeValue('blue.700', 'blue.500');

    return (
        <Box position={"relative"}>
            <Flex zIndex={999} position={"fixed"} bottom={5} right={3}>
                <Button
                    onClick={() => {
                        setIsEdit(false);
                        resetForm();
                        onOpen();
                    }}
                    colorScheme='purple'
                >
                    <PiPlusBold size={18} />

                </Button>
            </Flex>

            <Box mt={2} mb={5}>
                <Breadcrumb fontWeight="medium" fontSize="2xl">
                    <BreadcrumbItem>
                        <BreadcrumbLink onClick={() => navigate('/')}>{t("Accueil")}</BreadcrumbLink>
                    </BreadcrumbItem>
                    <BreadcrumbItem isCurrentPage>
                        <BreadcrumbLink>{t("Gestion Facture")}</BreadcrumbLink>
                    </BreadcrumbItem>
                </Breadcrumb>
            </Box>

            <Card rounded="2xl" shadow="sm" border="1px" borderColor={useColorModeValue('gray.100', 'gray.700')}>
                <CardBody p={6}>
                    <Flex gap={4} mb={6} direction={{ base: 'column', md: 'row' }}>
                        <InputGroup maxW={{ md: "400px" }}>
                            <InputLeftElement pointerEvents='none'>
                                <SearchIcon color='gray.300' />
                            </InputLeftElement>
                            <Input
                                placeholder={t("Rechercher par facture, compte ou source...")}
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                rounded="xl"
                            />
                        </InputGroup>
                        <Box w={{ base: '100%', md: '250px' }}>
                            <Popover placement="bottom-start">
                                <PopoverTrigger>
                                    <InputGroup size="md">
                                        <Input
                                            readOnly
                                            value={dateDebutValue ? `${dateDebutValue} ${t("au")} ${dateFinValue}` : t("Choisir une période")}
                                            cursor="pointer"
                                            rounded="xl"
                                            borderColor={useColorModeValue('gray.200', 'gray.600')}
                                            bg={useColorModeValue('white', 'gray.700')}
                                            _hover={{ borderColor: 'purple.400' }}
                                            _focus={{ borderColor: 'purple.500', boxShadow: 'none' }}
                                        />
                                        {dateDebutValue && (
                                            <InputRightElement w="auto" pr={2}>
                                                <IconButton
                                                    variant="ghost"
                                                    size="sm"
                                                    icon={<CloseButton size="sm" />}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        clearDateRange();
                                                    }}
                                                    aria-label={t("Effacer la date")}
                                                />
                                            </InputRightElement>
                                        )}
                                    </InputGroup>
                                </PopoverTrigger>
                                <Portal>
                                    <PopoverContent w="auto" p={0} border="none" shadow="2xl" zIndex={9999}>
                                        <PopoverArrow />
                                        <PopoverBody p={0}>
                                            <DateRange
                                                ranges={[selectionRange]}
                                                onChange={handleSelectDateRange}
                                                locale={fr}
                                                maxDate={new Date()}
                                                rangeColors={['#805AD5']}
                                            />
                                        </PopoverBody>
                                    </PopoverContent>
                                </Portal>
                            </Popover>
                        </Box>

                        <IconButton
                            icon={<RiFileExcel2Fill />}
                            onClick={onOpenExportAlert}
                            colorScheme="green"
                            variant="outline"
                            rounded="xl"
                            aria-label={t("Exporter Excel")}
                            title={t("Exporter en Excel")}
                        />
                        <IconButton
                            icon={<GrPowerReset />}
                            onClick={resetFilters}
                            variant="outline"
                            colorScheme="purple"
                            rounded="xl"
                            aria-label={t("Réinitialiser")}
                            title={t("Réinitialiser les filtres")}
                        />
                    </Flex>

                    <TableContainer>
                        <Table variant='simple'>
                            <Thead>
                                <Tr>
                                    <Th>{t("Factures")}</Th>
                                    <Th>{t("Compte Récepteur")}</Th>
                                    <Th>{t("Source")}</Th>
                                    <Th isNumeric>{t("Total")}</Th>
                                    <Th>{t("Date Création")}</Th>
                                    <Th>{t("Reçu")}</Th>
                                    <Th>{t("Options")}</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {loadingData ? (
                                    <Tr><Td colSpan={7}><Skeleton height="20px" count={5} /></Td></Tr>
                                ) : (data?.length === 0 || !data) ? (
                                    <Tr><Td colSpan={7} textAlign="center">{t("Aucune donnée trouvée")}</Td></Tr>
                                ) : data.map((row) => (
                                    <Tr key={row.id}>
                                        <Td fontWeight="bold">{row.factures}</Td>
                                        <Td>{row.compte_recepteur}</Td>
                                        <Td>{row.source}</Td>
                                        <Td>
                                            <Flex gap={1} alignItems="center">
                                                <Text fontWeight='semibold'>{row.total}</Text>
                                                <Text h={"100%"} fontSize={12} >{currentBusiness?.currency}</Text>
                                            </Flex>
                                        </Td>
                                        <Td>
                                            <Flex flexDirection="column">
                                                <Text fontSize="sm" fontWeight="medium">{new Date(row.date_creation).toLocaleDateString()}</Text>
                                                <Text fontSize="xs" color="gray.500">{new Date(row.date_creation).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</Text>
                                            </Flex>
                                        </Td>
                                        <Td>
                                            {((row.receipts && row.receipts.length > 0) || row.recu) ? (
                                                <HStack spacing={1}>
                                                    {[...(row.receipts || []), ...(row.recu ? [{file: row.recu, isLegacy: true}] : [])].map((r, i) => {
                                                        const isPdf = r.file?.toLowerCase().endsWith('.pdf');
                                                        return (
                                                            <Tooltip key={i} label={`${t("Reçu")} #${i + 1}${r.isLegacy ? ' (Ancien)' : ''}`}>
                                                                <Link href={r.file} isExternal>
                                                                    <Center
                                                                        w="30px"
                                                                        h="30px"
                                                                        bg={isPdf ? "red.50" : "blue.50"}
                                                                        color={isPdf ? "red.500" : "blue.500"}
                                                                        rounded="lg"
                                                                        transition="all 0.2s"
                                                                        _hover={{ transform: 'translateY(-2px)', shadow: 'sm', bg: isPdf ? "red.100" : "blue.100" }}
                                                                        border="1px solid"
                                                                        borderColor={isPdf ? "red.200" : "blue.200"}
                                                                    >
                                                                        <Icon as={isPdf ? FaFilePdf : FaImage} fontSize="14px" />
                                                                    </Center>
                                                                </Link>
                                                            </Tooltip>
                                                        )
                                                    })}
                                                </HStack>
                                            ) : (
                                                <Text fontSize="xs" color="gray.400">{t("Aucun")}</Text>
                                            )}
                                        </Td>
                                        <Td>
                                            <Menu>
                                                <MenuButton as={IconButton} icon={<HamburgerIcon />} variant="ghost" rounded="full" />
                                                <MenuList>
                                                    <MenuItem onClick={() => openEdit(row)} icon={<EditIcon />}>{t("Modifier")}</MenuItem>
                                                    <MenuItem onClick={() => { setId(row.id); onOpenAlert(); }} icon={<DeleteIcon />} color="red.500">{t("Supprimer")}</MenuItem>
                                                </MenuList>
                                            </Menu>
                                        </Td>
                                    </Tr>
                                ))}
                            </Tbody>
                        </Table>
                    </TableContainer>

                    {data && data.length > 0 && (
                        <Flex mt={6} justify="space-between" align="center">
                            <MyPagination
                                paginationData={paginationData}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                                PAGE_SIZE={pageSize}
                            />
                            <Select w="100px" value={pageSize} onChange={handlePageSizeChange} rounded="xl">
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="50">50</option>
                            </Select>
                        </Flex>
                    )}
                </CardBody>
            </Card>

            {/* Modal Add/Edit */}
            <Modal isOpen={isOpen} onClose={onClose} size="xl">
                <ModalOverlay backdropFilter="blur(4px)" />
                <ModalContent rounded="2xl">
                    <ModalHeader borderBottomWidth="1px">{isEdit ? t("Modifier Facture") : t("Ajouter Facture")}</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody py={6}>
                        {message && <Alert status="error" mb={4} rounded="xl"><AlertIcon />{message}</Alert>}
                        <Stack spacing={4}>
                            <FormControl isRequired>
                                <FormLabel>{t("Factures")}</FormLabel>
                                <Input value={factures} onChange={(e) => setFactures(e.target.value)} placeholder={t("Référence facture...")} rounded="xl" />
                            </FormControl>
                            <Flex gap={4}>
                                <FormControl>
                                    <FormLabel>{t("Compte Récepteur")}</FormLabel>
                                    <Input value={compteRecepteur} onChange={(e) => setCompteRecepteur(e.target.value)} placeholder={t("RIB ou nom compte...")} rounded="xl" />
                                </FormControl>
                                <FormControl>
                                    <FormLabel>{t("Source")}</FormLabel>
                                    <Input value={source} onChange={(e) => setSource(e.target.value)} placeholder={t("Source des fonds...")} rounded="xl" />
                                </FormControl>
                            </Flex>
                            <FormControl isRequired>
                                <FormLabel gap={1} alignItems="center" display={"flex"}>
                                    <Text>{t("Total")}</Text>
                                    <Text h={"100%"} fontSize={12} >{currentBusiness?.currency}</Text>
                                </FormLabel>
                                <Input
                                    type="text"
                                    value={total}
                                    onChange={(e) => {
                                        const val = handlePriceChange(e.target.value);
                                        if (val !== null) setTotal(val);
                                    }}
                                    rounded="xl"
                                />
                            </FormControl>

                            <FormControl>
                                <FormLabel>{t("Reçus (Max 5, Image/PDF, Max 4Mo)")}</FormLabel>
                                <Box
                                    border="2px dashed"
                                    borderColor="gray.200"
                                    p={4}
                                    rounded="xl"
                                    textAlign="center"
                                    cursor="pointer"
                                    _hover={{ borderColor: 'purple.400', bg: 'purple.50' }}
                                    position="relative"
                                >
                                    <Input
                                        type="file"
                                        multiple
                                        accept="image/*,.pdf"
                                        opacity={0}
                                        position="absolute"
                                        top={0}
                                        left={0}
                                        w="100%"
                                        h="100%"
                                        cursor="pointer"
                                        onChange={async (e) => {
                                            const files = Array.from(e.target.files);
                                            const validFiles = [];
                                            const extensions = ['.png', '.jpg', '.jpeg', '.webp', '.pdf'];
                                            
                                            if (receipts.length + existingReceipts.length + files.length > 5) {
                                                toast({ description: t("Max 5 fichiers au total"), status: 'warning' });
                                                return;
                                            }

                                            for (const file of files) {
                                                const ext = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
                                                if (!extensions.includes(ext)) {
                                                    toast({ description: `${file.name}: ${t("Format non supporté")}`, status: 'error' });
                                                    continue;
                                                }
                                                if (file.name.length > 50) {
                                                    toast({ description: `${file.name}: ${t("Nom trop long (max 50)")}`, status: 'error' });
                                                    continue;
                                                }
                                                if (file.size > 4 * 1024 * 1024) {
                                                    toast({ description: `${file.name}: ${t("Fichier trop volumineux (max 4Mo)")}`, status: 'error' });
                                                    continue;
                                                }

                                                if (file.type.startsWith('image/')) {
                                                    const resized = await new Promise((resolve) => {
                                                        Resizer.imageFileResizer(
                                                            file, 800, 800, 'JPEG', 80, 0,
                                                            (uri) => resolve(uri), 'file'
                                                        );
                                                    });
                                                    validFiles.push(resized);
                                                } else {
                                                    validFiles.push(file);
                                                }
                                            }
                                            setReceipts([...receipts, ...validFiles]);
                                        }}
                                    />
                                    <AttachmentIcon color="gray.400" mb={2} />
                                    <Text fontSize="sm" color="gray.500">
                                        {receipts.length > 0 ? `${receipts.length} ${t("fichiers sélectionnés")}` : t("Cliquez ou glissez des fichiers ici")}
                                    </Text>
                                </Box>
                                {receipts.length > 0 && (
                                    <Flex wrap="wrap" gap={2} mt={2}>
                                        {receipts.map((f, i) => (
                                            <Badge key={i} colorScheme="purple" p={1} px={2} rounded="md" display="flex" alignItems="center">
                                                <a href={URL.createObjectURL(f)} target="_blank" rel="noreferrer" style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                                    <AttachmentIcon mr={1} fontSize="10px" />
                                                    {f.name.substring(0, 15)}...
                                                </a>
                                                <IconButton
                                                    size="xs" ml={2} icon={<CloseIcon />} 
                                                    variant="ghost"
                                                    _hover={{ bg: 'red.100', color: 'red.500' }}
                                                    onClick={() => setReceipts(receipts.filter((_, idx) => idx !== i))}
                                                />
                                            </Badge>
                                        ))}
                                    </Flex>
                                )}
                                {existingReceipts.length > 0 && (
                                    <>
                                        <Text fontSize="xs" mt={3} mb={1} fontWeight="bold">{t("Reçus enregistrés")}:</Text>
                                        <Flex wrap="wrap" gap={2}>
                                            {existingReceipts.map((r, i) => (
                                                <Badge key={i} colorScheme="green" p={1} px={2} rounded="md" display="flex" alignItems="center">
                                                    <Link href={r.file} isExternal display="flex" alignItems="center" _hover={{ opacity: 0.7 }}>
                                                        <AttachmentIcon mr={1} fontSize="10px" />
                                                        {t("Reçu")} {i + 1} {r.isLegacy ? `(${t("Ancien")})` : ''}
                                                    </Link>
                                                    <IconButton
                                                        size="xs" ml={2} icon={<CloseIcon />} 
                                                        onClick={() => handleDeleteReceipt(r.id)}
                                                        variant="ghost"
                                                        _hover={{ bg: 'red.100', color: 'red.500' }}
                                                    />
                                                </Badge>
                                            ))}
                                        </Flex>
                                    </>
                                )}
                            </FormControl>
                        </Stack>
                    </ModalBody>
                    <ModalFooter borderTopWidth="1px">
                        <Button variant="ghost" mr={3} onClick={onClose} rounded="xl">{t("Annuler")}</Button>
                        <Button colorScheme="purple" onClick={handleSave} rounded="xl">{t("Enregistrer")}</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            {/* AlertDialog Delete */}
            <AlertDialog isOpen={isAlertOpen} leastDestructiveRef={cancelRef} onClose={onCloseAlert}>
                <AlertDialogOverlay>
                    <AlertDialogContent rounded="2xl">
                        <AlertDialogHeader fontSize="lg" fontWeight="bold">{t("Supprimer Facture")}</AlertDialogHeader>
                        <AlertDialogBody>{t("Êtes-vous sûr ? Cette action est irréversible.")}</AlertDialogBody>
                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={onCloseAlert} rounded="xl">{t("Annuler")}</Button>
                            <Button colorScheme="red" onClick={() => handleDelete(id)} ml={3} rounded="xl">{t("Supprimer")}</Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>

            <AlertDialog isOpen={isReceiptAlertOpen} leastDestructiveRef={cancelRef} onClose={() => setIsReceiptAlertOpen(false)}>
                <AlertDialogOverlay>
                    <AlertDialogContent rounded="2xl">
                        <AlertDialogHeader fontSize="lg" fontWeight="bold">{t("Supprimer le reçu")}</AlertDialogHeader>
                        <AlertDialogBody>{t("Êtes-vous sûr de vouloir supprimer ce reçu ?")}</AlertDialogBody>
                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={() => setIsReceiptAlertOpen(false)} rounded="xl">{t("Annuler")}</Button>
                            <Button colorScheme="red" onClick={confirmDeleteReceipt} ml={3} rounded="xl">{t("Supprimer")}</Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>
            <AlertDialog isOpen={isExportAlertOpen} leastDestructiveRef={cancelRef} onClose={onCloseExportAlert}>
                <AlertDialogOverlay backdropFilter="blur(3px)">
                    <AlertDialogContent rounded="2xl">
                        <AlertDialogHeader fontSize="lg" fontWeight="bold">
                            {t("Confirmer l'exportation")}
                        </AlertDialogHeader>
                        <AlertDialogBody>
                            {t("Attention : l'exportation Excel dépendra des filtres actuellement appliqués sur la page. Voulez-vous continuer ?")}
                        </AlertDialogBody>
                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={onCloseExportAlert}>{t("Annuler")}</Button>
                            <Button colorScheme="green" onClick={() => { onCloseExportAlert(); handleExportExcel(); }} ml={3}>{t("Exporter")}</Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>
        </Box>
    )
}

export default GestFinance;
